

import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {IParsedStackedSymbolName, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";

export class HarlequinSpinReelController extends NudgeSpinReelController {

    protected _exTopSymbols:string [] = [];
    protected _tmpStop:string [] = [];
    protected _doNu:boolean = false;
    private _hData:HarlequinParsedGameData;

    constructor(reelId:number) {
        super(reelId);
    }

    public updateGameData(data:ParsedGameData):void {
        this._hData = <HarlequinParsedGameData> data;
        this._gameMode = data.mode;
        this._nextGameMode = data.nextMode;
        this._stopReelSet = data.reels[this._reelId];
        //this._nextFullReelSet = Helper.getReelSet(data.nextReelSetName, this._reelId);
        //EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName: this._gameMode}));
       //this._nearWinReels = data.nearWinReels.concat();
        //this._nearWinBigWinReels = data.nearWinBigWinReels.concat();
    }

    protected onSpinStepCompleted(): void {
        const symbol:StateReelSymbol | null = Reels.getSymbol(this._reelId, 0, true);
        if(symbol && symbol.symName.indexOf("W") > -1) {
            //console.log("SYM NAME:" + symbol.symName);
            if(this._hData && !this._hData.wildOverlayReels[this._reelId]) {
                HarlequinGameModuleConfig.nearWinView.playWildOmenOnReel(this._reelId, false);
            }
        }
        super.onSpinStepCompleted();
    }

    public updateGameDataOnStart(data:ParsedGameData):void {
        //this._nextFullReelSet = Helper.getReelSet(data.nextReelSetName, this._reelId);
    }

    // TODO: stopReelSet is overridden here to prevent exception and weird game behavior, but I suspect the actual error is originated in below function: this._stopReelSet = [];
    // TODO: Race condition
    /*public startSpin(data:IReelStartSpinData, previousDelay:number):number {
        this.setStartSpinData(data);
        if(data.active) {
            this._stopReelSet = [];
            this._isSpinning = true;
            this._reelStopPresentationCompleted = false;
            return this.startSpinAnimation(data, previousDelay);
        } else {
            // If reel is not active we fake a spin started and send the complete event when receiving stop.
            this._currentState = ReelAnimationState.INACTIVE;
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_SPIN_STARTED, this._reelId));
            return previousDelay;
        }
    }*/

    // The stop offset is for features on the reel to prolong the stop.
    // The reelArea will take the biggest offset as the real stop offset.
    /*public getSpinStopOffset():number {
        if(this._currentState === ReelAnimationState.INACTIVE || this._currentState === ReelAnimationState.IDLE) {
            return 0;
        }

        // check if there is unfinished stacked wilds in the bottom of the stop reel set.
        // When the offset is more than 0, we have to make sure to compensate it from the stop reel set.
        let spinStopOffset:number = 0;
        let bottomSymbol:string = this._tmpStop[this._tmpStop.length - 1];


        let parsedStackedName: IParsedStackedSymbolName = StateReelSymbol.parseStackedSymbolName(bottomSymbol, this._reelId);
        if (parsedStackedName.isStacked && parsedStackedName.index < (parsedStackedName.totalNum - 1)) {
            spinStopOffset = parsedStackedName.totalNum - 1 - parsedStackedName.index;
        }


        return Math.max(0, spinStopOffset - GameConfig.instance.SYMBOLS_NUM_IN_REEL[4]);
    }

    protected makeUpStopReelSet(bottomFillUpTotalNum:number, init:boolean):string[] {
        const randomPosition:number = this.randomizeReelSetPosition(this._nextFullReelSet);
        const topFillUp:string[] = this.makeUpStackedSymbolTop(this._tmpStop[0]);
        const bottomFillUp:string[] = this.makeUpStackedSymbolBottom(this._tmpStop[this._tmpStop.length - 1], bottomFillUpTotalNum, init);
        const bottomRandomFillUp:string[] = this.makeUpStopReelSetRandomBottomFillUp(bottomFillUpTotalNum - bottomFillUp.length, init);
        return this._nextFullReelSet.slice(0, randomPosition + 1).concat(topFillUp).concat(this._tmpStop).concat(bottomFillUp).concat(bottomRandomFillUp);
    }


    protected onGameDataParsed(data:INudgeParsedGameData):void {
        super.onGameDataParsed(data);
        this._doNu = this.parseDoNudge(data);
        this._exTopSymbols = (data.extraSymbolsOnTop != null && data.extraSymbolsOnTop[this._reelId] != null) ? data.extraSymbolsOnTop[this._reelId] : [];
        this._stopReelSet = data.reels[this._reelId];
        this._tmpStop = data.reels[this._reelId];
    }

    protected parseInitData(data:ParsedInitData):void {

        super.parseInitData(data);
        this._tmpStop = data.reels[this._reelId].concat();
    }

    protected parseDoNudge(data: INudgeParsedGameData): boolean {
        const isReelNudge : boolean = (data.doReelNudge != null && data.doReelNudge[this._reelId] != null) ? data.doReelNudge[this._reelId] : false;
        return isReelNudge;
    }*/
}